import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../shared/nestjs/nest-api";
import {
  ResponseGetListEmpRehireDto,
} from "../../shared/nestjs/gd-only/dto/sf-profile.dto";
import {SharedLogic} from "./shared.logic";

@Injectable()
export class EmpRehireLogic {
  constructor(
    private nestApiProvider: NestApiProvider,
    private sharedLogic: SharedLogic,
  ) {
  }

  getListEmpRehire(limit: string | number, page: string | number, q: string): Promise<ResponseGetListEmpRehireDto> {
    return new Promise<ResponseGetListEmpRehireDto>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      try {
        if (isGoPathNewExist) {
          const result = await this.sharedLogic.getListEmpRehireNest(limit, page, q);
          resolve(result);
        }
      } catch (e) {
        reject(e);
      }
    })
  }

  getSearchEmployeeRehire(data: SearchEmployeeRehireParam): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const result = await this.sharedLogic.searchEmployeeRehire(data);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    })
  }
}

export interface SearchEmployeeRehireParam {
  textSearch: string;
  position: any;
  userId: number;
  companyId: number;
  limit: number;
  skip: number;
}



// WEBPACK FOOTER //
// ./src/providers/component-logic/emp-rehire.logic.ts